export default "__VITE_ASSET__CrBS1YV1__"